interface ISelectMenu {
    children: React.ReactElement,
    innerProps: {
        [key: string]: any
    }
}

const SelectMenu: React.FC<ISelectMenu> = ({ innerProps, children }) => {
    return (
      <div
        {...innerProps}
        className="bg-white z-50 overflow-auto customReactSelectMenu rounded mt-1 border absolute w-full">
        {children}
      </div>
    );
};

export default SelectMenu;